import { RouteRecordRaw } from 'vue-router'

const Products = () =>
  import(/* webpackChunkName: "products-view" */ './pages/index.vue')

const ProductsShow = () =>
  import(/* webpackChunkName: "products-show" */ './pages/ShowPage.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'productos',
    name: 'products',
    component: Products,
    meta: {
      title: 'Productos',
      auth: {
        requiredPermission: 'products.view',
        requiredModule: 'products',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
  {
    path: 'productos/:ulid',
    name: 'products-show',
    component: ProductsShow,
    meta: {
      title: 'Producto',
      auth: {
        requiredPermission: 'products.view',
        requiredModule: 'products',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
